module.exports = __webpack_public_path__ + "static/media/icon_service_sdk.3325d3f1.svg";